export default __webpack_public_path__ + "43e6db7b46c95da6f9a50cd6c4b4d100.png";